import type { ChatMessengerElement } from '@/types/chat-messenger';
import { ROUTES } from '@constants';
import { CartContext } from '@utils/CartContext';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { initUjetHandoff, type UjetUserRef } from './ujetHandoff';

const GOOGLE_AGENT_TOOLS_BASE = process.env.NEXT_PUBLIC_CX_AGENT_STUDIO_TOOLS_BASE || '';

export const useClientSideFunctions = (
  userRef: UjetUserRef,
): ((messenger: ChatMessengerElement) => void) => {
  const router = useRouter();
  const { setIsCartDrawerOpen } = useContext(CartContext);

  return (messenger: ChatMessengerElement): void => {
    if (!messenger) return;

    const TOOLS = [ {
      path: `${GOOGLE_AGENT_TOOLS_BASE}/67ea1e5c-f7c4-478b-89df-953f77c99745`,
      id: '67ea1e5c-f7c4-478b-89df-953f77c99745',
      handler: (): Promise<{ status: string }> =>
        router
          .push('/my-account')
          .then(() => Promise.resolve({ status: 'success' }))
          .catch(() => Promise.resolve({ status: 'error' })),
    },
    {
      path: `${GOOGLE_AGENT_TOOLS_BASE}/bf8185b5-8a73-4ad9-975f-49526380d15a`,
      id: 'bf8185b5-8a73-4ad9-975f-49526380d15a',
      handler: (payload): Promise<{ status: string }> => {
        switch (payload?.page_name) {
        case 'checkout':
          return router
            .push(ROUTES.checkout)
            .then(() => Promise.resolve({ status: 'success' }))
            .catch(() => Promise.resolve({ status: 'error' }));
        case 'cart':
          setIsCartDrawerOpen(true);

          return Promise.resolve({ status: 'success' });
        default:
          return Promise.resolve({ status: 'error' });
        }
      },
    },
    {
      path: `${GOOGLE_AGENT_TOOLS_BASE}/9ae5f0e4-dec5-4776-817e-50f4868fc278`,
      id: '9ae5f0e4-dec5-4776-817e-50f4868fc278',
      handler: (): Promise<{ status: string }> =>
        initUjetHandoff(messenger, userRef)
          .then(() => ({ status: 'success' }))
          .catch(() => ({ status: 'error' })),
    }, ];

    TOOLS.forEach(tool => {
      messenger.registerClientSideFunction(tool.path, tool.id, tool.handler);
    });
  };
};
